<script>
  import { Tooltip } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  import { classnames } from '@client/utils/classnames';

  import { generateUUID } from '@common/utils/strings';

  /**
   * Optional custom class name(s) applied to the icon wrapper.
   * @type {string}
   */
  let className = '';
  export { className as class };

  /**
   * The background color for the event icon.
   * Can be any valid CSS color string.
   * @type {string}
   */
  export let color = 'var(--bs-secondary-bg)';

  /**
   * The icon name (passed to the Icon component).
   * Should match a valid icon name.
   * @type {string | undefined}
   */
  export let icon = undefined;

  /**
   * Optional tooltip text to show on hover.
   * @type {string | undefined}
   */
  export let tooltip = undefined;

  /**
   * Unique tooltip ID.
   * @type {string}
   */
  const id = `tooltip-${generateUUID()}`;

  /**
   * Computed CSS classes for the wrapper element.
   * @type {string}
   */
  $: classes = classnames(className, 'event');
</script>

<i {...$$restProps} class={classes} style="background-color: {color}">
  <Icon name={icon} color="white" {id} />

  {#if tooltip}
    <Tooltip target={id} placement="right">
      {tooltip}
    </Tooltip>
  {/if}
</i>

<style lang="scss" src="./activity-event-icon.scss"></style>
